import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Typography, Button, TextField } from "@material-ui/core";
import {
  addTask,
  toggleBeingEdited,
  editTask,
} from "../../../../store/tasks/actions";
import useStyles from "./styles";

const EditTask = ({
  onClose,
  oldTitle,
  oldDescription,
  beingEdited,
  taskKey,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [title, setTitle] = useState(oldTitle);
  const [description, setDescription] = useState(oldDescription);
  const [error, setError] = useState(false);

  const submit = () => {
    if (beingEdited) {
      dispatch(
        editTask({
          key: taskKey,
          title: title,
          description: description,
        })
      );
    } else {
      dispatch(
        addTask({
          title: title,
          description: description,
          beingEdited: false,
          complete: false,
        })
      );
      onClose();
    }
  };

  const attemptSubmit = () => {
    if (!title) {
      setError(true);
    } else {
      submit();
    }
  };

  const onCancel = () => {
    beingEdited
      ? dispatch(
          toggleBeingEdited({
            key: taskKey,
          })
        )
      : onClose();
  };

  return (
    <div className={classes.editTask}>
      <TextField
        label="Task Title"
        variant="outlined"
        className={classes.textfield}
        onChange={(event) => {
          setTitle(event.target.value);
          setError(false);
        }}
        value={title}
        error={error}
        required={true}
      />
      <TextField
        label="Description"
        variant="outlined"
        className={classes.textfield}
        value={description}
        onChange={(event) => setDescription(event.target.value)}
      />
      <div className={classes.buttonGroup}>
        <Button
          variant="outlined"
          className={classes.cancel}
          onClick={onCancel}
        >
          <Typography>Cancel</Typography>
        </Button>
        <Button
          variant="outlined"
          className={classes.done}
          onClick={attemptSubmit}
        >
          <Typography>Done</Typography>
        </Button>
      </div>
    </div>
  );
};

export default EditTask;
